import { Color, Spacing } from '@persona-id/design-tokens';
import styled, { css } from 'styled-components';

import Spacer from 'design-system/components/Spacer';
import ImageCircleAlert from 'images/dashboard/circle-alert.svg';
import ImageCirclePositive from 'images/dashboard/circle-positive.svg';

const BASE_ICON_STYLES = css`
  width: ${Spacing[5]};
  flex-shrink: 0;
`;

const StyledIconPositive = styled(ImageCirclePositive)`
  ${BASE_ICON_STYLES}
  > * {
    stroke: ${Color.CoreGreen500};
  }
`;

const StyledIconAlert = styled(ImageCircleAlert)<{ color?: string }>`
  ${BASE_ICON_STYLES}
  > * {
    stroke: ${(props) => props.color ?? Color.CoreRed700};
    stroke-width: 2;
  }
`;

const StyledIconWarning = () => <StyledIconAlert color={Color.CoreYellow500} />;

const Container = styled.div`
  display: flex;
  align-items: center;
`;

interface MatchIconProps {
  label?: string;
}

export const MatchIconPositive = ({ label }: MatchIconProps) => (
  <Container>
    <StyledIconPositive />
    {label && <Spacer width={1} height={0} />}
    {label}
  </Container>
);

export const MatchIconAlert = ({ label }: MatchIconProps) => (
  <Container>
    <StyledIconAlert />
    {label && <Spacer width={1} height={0} />}
    {label}
  </Container>
);

export const MatchIconWarning = ({ label }: MatchIconProps) => (
  <Container>
    <StyledIconWarning />
    {label && <Spacer width={1} height={0} />}
    {label}
  </Container>
);

export const MatchIconDismissed = ({ label }: MatchIconProps) => (
  <Container>
    <StyledIconAlert color={Color.CoreSlate200} />
    {label && <Spacer width={1} height={0} />}
    {label}
  </Container>
);
